var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "bg-white shadow rounded-lg mt-10 pt-4 pb-10",
      attrs: { "data-vv-scope": "tags-form" }
    },
    [
      _c(
        "b-alert",
        { staticClass: "m-5", attrs: { variant: "info", show: "" } },
        [
          _c("div", { staticClass: "alert-body" }, [
            _c("span", { staticClass: "text-sm text-gray-600" }, [
              _vm._v(
                " * Pincha sobre el candado para activar/desactivar esta sección. "
              )
            ])
          ])
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "px-2 py-2 pl-md-4 pr-md-4 ml-md-5 mr-md-5 justify-content-between d-flex"
        },
        [
          _c(
            "span",
            { staticClass: "text-base leading-6 font-medium text-gray" },
            [
              _vm._v(" Etiquetas "),
              _c("span", { staticClass: "badge badge-secondary" }, [
                _vm._v(_vm._s(_vm.elementTags.length))
              ])
            ]
          ),
          _c(
            "b-button",
            {
              staticClass: "btn-icon rounded-circle cursor-pointer border-none",
              class: {
                "cursor-not-allowed":
                  _vm.userPermissions.write === 0 &&
                  _vm.userPermissions.totalControl === 0 &&
                  !_vm.hasPermission("FEB99")
              },
              attrs: {
                variant: _vm.disabled ? "flat-danger" : "flat-success",
                disabled:
                  _vm.userPermissions.write === 0 &&
                  _vm.userPermissions.totalControl === 0 &&
                  !_vm.hasPermission("FEB99")
              },
              on: {
                click: function($event) {
                  _vm.disabled = !_vm.disabled
                }
              }
            },
            [
              _c(
                "transition",
                { attrs: { "enter-active-class": "animated fadeIn" } },
                [
                  _vm.disabled
                    ? _c("feather-icon", { attrs: { icon: "LockIcon" } })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { "enter-active-class": "animated fadeIn" } },
                [
                  !_vm.disabled
                    ? _c("feather-icon", { attrs: { icon: "UnlockIcon" } })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "border-t border-gray-200 m-5" },
        [
          !_vm.disabled
            ? _c(
                "v-select",
                {
                  attrs: {
                    placeholder:
                      "Selecciona una o mas etiquetas existentes o crea una nueva.",
                    options: _vm.companyTags,
                    taggable: "",
                    multiple: ""
                  },
                  on: {
                    "option:selecting": _vm.addElementTag,
                    "option:selected": _vm.removeFails,
                    "option:deselecting": _vm.deleteElementTag
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "search",
                        fn: function(ref) {
                          var attributes = ref.attributes
                          var events = ref.events
                          return [
                            _c(
                              "input",
                              _vm._g(
                                _vm._b(
                                  {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "alpha_num",
                                        expression: "'alpha_num'"
                                      }
                                    ],
                                    staticClass: "vs__search",
                                    attrs: {
                                      name: "tags",
                                      "data-vv-as": "Etiquetas"
                                    }
                                  },
                                  "input",
                                  attributes,
                                  false
                                ),
                                events
                              )
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    3006515563
                  ),
                  model: {
                    value: _vm.elementTags,
                    callback: function($$v) {
                      _vm.elementTags = $$v
                    },
                    expression: "elementTags"
                  }
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "no-options" }, slot: "no-options" },
                    [_vm._v("No existen opciones para seleccionar.")]
                  )
                ]
              )
            : _vm.elementTags.length
            ? _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  _vm._l(_vm.elementTags, function(tag, index) {
                    return _c(
                      "b-badge",
                      {
                        key: "tag_" + index,
                        staticClass: "cursor-not-allowed mr-3",
                        attrs: { variant: "light-secondary" }
                      },
                      [_vm._v(" " + _vm._s(tag) + " ")]
                    )
                  }),
                  1
                )
              ])
            : _vm._e(),
          _c("FormError", {
            attrs: { attributeName: "tags-form.tags", errorsForm: _vm.errors }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }